import type { Meeting } from '@beeboard/common';

/**
 * Returns a sorted copy of the given meetings, ordered by `started_at`
 * descending (newest meeting date first). The input array is not mutated —
 * Pinia getter consumers must not re-order store state as a side effect.
 *
 * The sort is stable (guaranteed for Array#sort since ES2019), so meetings
 * with an identical `started_at` keep their incoming relative order. The API
 * returns meetings ordered by creation date descending, which makes the
 * effective tiebreaker `created_at` descending (the Meeting DTO itself does
 * not expose `created_at`).
 */
export function sortMeetingsByStartedAt(meetings: Meeting[]): Meeting[] {
  return [...meetings].sort(
    (a, b) =>
      new Date(b.started_at).getTime() - new Date(a.started_at).getTime(),
  );
}
